// extracted by mini-css-extract-plugin
module.exports = {"Loading":"wm_a bag_a bag_w bag_j bag_rj bag_rk bag_fg"};